import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, duration = 0.9, once = true, className = '', as = 'div', ...rest }) => {
  const reduce = useReducedMotion();
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '0px 0px -8% 0px' }}
      transition={{ duration, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </Comp>
  );
};

const containerVariants = (stagger, delay) => ({
  hidden: {},
  show: { transition: { staggerChildren: stagger, delayChildren: delay } },
});

const itemVariants = (y) => ({
  hidden: { opacity: 0, y },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: EASE } },
});

export const Stagger = ({ children, stagger = 0.09, delay = 0, once = true, className = '', ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      variants={containerVariants(stagger, delay)}
      initial={reduce ? 'show' : 'hidden'}
      whileInView="show"
      viewport={{ once, margin: '0px 0px -8% 0px' }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const StaggerItem = ({ children, y = 28, className = '', as = 'div', ...rest }) => {
  const Comp = motion[as] || motion.div;
  return (
    <Comp variants={itemVariants(y)} className={className} {...rest}>
      {children}
    </Comp>
  );
};

export default Reveal;
